<template>
  <div class="dev-history-root">
    <!-- <div class="area-layout0"></div> -->
    <!-- <img src="@images/bg/dh_all.png" alt="" /> -->
    <div class="root-scrollbar root">
      <!-- <div class="area-layout0"></div> -->
      <img
        v-if="imageUrl"
        :class="language == 'en-US' ? 'area-layout-en' : 'area-layout'"
        :src="imageUrl"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { getData } from '@/request/api/model'
const CATEGORY_ID = '1985184895221714945'

export default {
  data() {
    return {
      language: localStorage.getItem('Language'),
      imageUrl: ''
    }
  },
  created() {
    this.getHistoryImage()
  },
  methods: {
    async getHistoryImage() {
      try {
        const res = await getData({
          categoryId: CATEGORY_ID,
          contentType: this.language === 'zh-CN' ? '0,1' : '0,2',
          publishChannel: '0,1'
        })

        if (!res || res.code !== 0 || !Array.isArray(res.data)) {
          return
        }
        const imageItem = res.data[0]
        if (imageItem) {
          this.imageUrl = imageItem.contentFileList.find((url) => {
            return typeof url === 'string' && url.trim()
          })
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dev-history-root {
  // height: calc(100vh - 190px);

  .root {
    height: 200px;
    height: calc(100vh - 16.75vh);
  }
  .area-layout {
    display: block;
    width: 100vw;
    height: calc(8710 / 1920 * 100vw);
  }
  .area-layout-en {
    display: block;
    width: 100vw;
    height: calc(12378 / 1920 * 100vw);
  }
}
</style>
